import React, { Component } from "react";
import Wrp from '../../../../../../hoc/Wrp/Wrp';
import moment from 'moment';
import ReminderOption from "./ReminderOption";
import RepeatOption from "./RepeatOption";
import {ReminderDisplayValue} from './ReminderFunction';
import 'moment-timezone';
import {getUserTimeZone} from '../../../../../../Utils/UserFunctions';
import {isSet} from '../../../../../../Utils/CommonFunctions';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Modal from "../../../../../UI/Modal";
// import {WeeksList,MonthsList} from './defaultList';
// import jwt from 'jwt-decode';

class Reminder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupMode:'REMINDER',
      // displayRepeat:'',
      repeatApplyButton:true,
      remindApplyButton:true,
      reminderJson:{
        tabledescriptor_id:this.props.item.id, 
        email_config_id:"",
        email_template_id:"",
        notified_users:[],
        is_active:true,
        remind_on: 0,//"0-n",
        remind_period: '',//"minute(s), hour(s), day(s), week(s), month(s), year(s)",
        remind_date: '',//"2020-12-31",
        is_remind_date: false,//for steps,
        remind_time: '',//"04:00 PM",
        is_remind_time: false,//for steps,
        repeat_type: null,//"Daily, Weekly, Monthly, Yearly, Custom",
        repeat_frequency:0,//"Daily, Weekly, Monthly, Yearly",
        repeat_every: 1,//"1-n",
        repeat_weekday: 1,//"0-6",
        repeat_dom: '',//"1-31",
        repeat_weekseq: 0,//"First, Second, Third, Fourth, Last",
        repeat_month: 0,//"0-11",
        repeat_ends: 'Never',//"Never, After 'n' Times, On 'DATE'",
        is_repeat_ends: false,//"Never, After 'n' Times, On 'DATE'",
        remind_alert: 2,//"Email, Pop Up, Both",
        start_date: moment().tz(getUserTimeZone()).format(getUserTimeZone('Date')),//"2020-12-18"
        start_time: moment().tz(getUserTimeZone()).format('HH:mm'),
        repeatOption:'DAY',
        remindOption:'DAY',
        display_text:[],
      }
    }
  }
  componentDidMount = ()=>{
    // const token = localStorage.getItem('access_token');
    // const user = jwt(token); 
    // console.log(user);
    // console.log(getUserTimeZone());
    if(this.props.selectedValue!==null && this.props.selectedValue!=='')
    try{
      if(typeof this.props.selectedValue.remind_time != "undefined"){
        console.log('this.props.selectedValue==',this.props.selectedValue)
        let remindValue = this.props.selectedValue;
        // console.log(remindValue);
        if(remindValue.remind_on===0){
          remindValue.remindOption = "DAY";
        }else{
          remindValue.remindOption = "CUSTOM";
        }
        if(remindValue.repeat_dom>0){
          remindValue.repeatOption = "DAY";
        }else{
          remindValue.repeatOption = "WEEK";
        }
        // console.log(remindValue);
        remindValue.start_date = moment().tz(getUserTimeZone()).format('YYYY-MM-DD');//"2020-12-18"
        remindValue.start_time = moment().tz(getUserTimeZone()).format('HH:MM');


        remindValue.is_remind_date = isSet(this.props.selectedValue.is_remind_date,this.state.reminderJson.is_remind_date);
        remindValue.is_remind_time = isSet(this.props.selectedValue.is_remind_time,this.state.reminderJson.is_remind_time);
        remindValue.is_repeat_ends = isSet(this.props.selectedValue.is_repeat_ends,this.state.reminderJson.is_repeat_ends);

        this.updateReminderComponentObject(remindValue);
        // this.setState({reminderJson:this.props.selectedValue})
      }
    }catch(e){
      console.log(e);
    }
  }
  render() {
    const {popupMode,reminderJson} = this.state;
    const {reminderDisplayText} = this.props;
    const dueDiff = moment(reminderJson.remind_date).diff(moment().tz(getUserTimeZone()).format(), 'days')+1;
    const objects = {
      ...this.state,
      ...this.props,
      dueDiff:dueDiff,
      actionChangeHandler:this.actionChangeHandler,
      actionChangeHandlerForFormula:this.actionChangeHandlerForFormula,
      clearRepeatOptions:this.clearRepeatOptions,
      popupModeChangeHandler:this.popupModeChangeHandler,
      updateReminderComponentObject:this.updateReminderComponentObject
    }
    
    let displayText = reminderDisplayText;
    // fieldGroups.map((section)=>{
    //   // console.log('section',section);
    //   if(section.access_mode!=='HIDDEN'){
    //     section.data.map((field)=>{
    //       if(field.access_mode!=='HIDDEN' && field.element!=='Reminder'){
    //         if(isSet(field.label,null)!==null){
    //           displayText.push({
    //             label:field.label.blocks[0].text,
    //             fieldId:field.id,
    //             sectionIndex:section.section_index
    //           })
    //         }
    //       }
    //     })
    //   }
    // });
    // console.log('displayText',displayText);
    console.log('reminderJson==',reminderJson)
    const reminderBtnList = [{
      attributes:{
        className:"btn secondary_bg mr-1",
        "data-dismiss":"modal",
        "id":"reminderCancel",
      },
      clickHandler:this.props.closeReminderPopup.bind(this,reminderJson),
      name:"Cancel"
    },
    {
      clickHandler:this.applyReminderHandler,
      attributes:{
          className:"btn primary_bg",
      },
      disabled:this.state.remindApplyButton,
      name:"Apply"
    }];

    const repeatBtnList = [{
      attributes:{
        className:"btn secondary_bg mr-1",
        "data-dismiss":"modal",
        "id":"repeatCancel",
      },
      clickHandler:this.cancelRepeatPopup,
      name:"Cancel"
    },
    {
      clickHandler:this.applyRepeatHandler,
      attributes:{
          className:"btn primary_bg",
      },
      disabled:this.state.repeatApplyButton,
      name:"Save"
    }];

    return (
      <Modal 
      isModalOpen={true}
      title={'Reminder'}
      modalDim={'modal-xl'}
      buttonList={(popupMode==='REMINDER')?reminderBtnList:repeatBtnList}>
          {/* <div className="hide reminderOuter" id="Div_5" style={{minWidth:'530px',position:'fixed',left:'50%',top:'100px',zIndex:'1115',display:'block'}}> */}
        {(popupMode==='REMINDER')?
          <Wrp>
          <ReminderOption
            {...objects}
            displayText={displayText}
            applyReminderHandler={this.applyReminderHandler} />
            {/* <span className="reminderCurrentDis">{moment().tz(getUserTimeZone()).format('YYYY-MM-DDTHH:mm')+':00'}</span> */}
          </Wrp>
        
        :
          <RepeatOption
            applyRepeatHandler={this.applyRepeatHandler} 
            {...objects} />
            
        }
      {/* </div>   */}
    </Modal>
        
    );
  }
  cancelRepeatPopup = ()=>{
    this.updateReminderComponentObject(this.state.reminderJson);
    this.popupModeChangeHandler('REMINDER');
    // actionChangeHandler(e,'repeat_type','none');
  }
  applyReminderHandler = ()=>{
    const {submitHandler} = this.props;
    const {reminderJson} = this.state;
    reminderJson.start_date = moment().tz(getUserTimeZone()).format('YYYY-MM-DD');
    reminderJson.start_time = moment().tz(getUserTimeZone()).format('HH:mm');
    const displayMsg = ReminderDisplayValue(reminderJson);
    //console.log('displayMsg===',displayMsg)
    submitHandler(displayMsg,reminderJson,'REMIND');
  }
  applyRepeatHandler =()=>{
    const  {reminderJson} = this.state;
    const {submitHandler} = this.props;
    const displayMsg = ReminderDisplayValue(reminderJson);
    submitHandler(displayMsg,reminderJson,'REPEAT');
    this.popupModeChangeHandler('REMINDER');
  }

  clearRepeatOptions = ()=>{
    const {submitHandler,displayReminder} = this.props;
    const {reminderJson} = this.state;
    displayReminder.repeat = '';
    submitHandler(displayReminder,reminderJson,'REPEAT');
  }

  // applyReminderChanges = ()=>{
  //   return this.state.reminderJson;
  // }
  // POPUP MODE (i.e.) REMINDER/REPEAT MODE POPUP
  popupModeChangeHandler  = (mode)=>{
    this.setState({popupMode:mode});
  }

  //CHANGE HANDLER FOR UPDATE REMINDER JSON
  actionChangeHandler = (e,obj,value,isFromSteps=false,isTagType=false)=>{
    //console.log('reminderJson== pre',obj,value);
    const {reminderJson} = this.state;

    let stepsExtraObj = {}
    let valueObj = {}
    if(isFromSteps === true){
      stepsExtraObj = {
        ['is_'+obj]:isTagType
      }

      // valueObj = {
      //   data_id: null,
      //   is_loop: false,
      //   is_variable_or_constant: true,
      //   is_window_field: false,
      //   name: isSet(value,[]).length>0?value[0].variable_name: "",
      //   value: isSet(value,[]).length>0?value[0].id: ""
      // }
      // value = [{...valueObj}];

      const dispName = [];
      let val = value;
      let selectedId = '';
      isSet(val,[]).map((dItem)=>{
          dispName.push(dItem.field_name);
          selectedId = dItem.id;
      });
      // console.log('dispName',dispName);
      const updateVal= (isSet(val,[]).length>0)?val[isSet(val,[]).length-1].window_field_id_path:'';
      let isLoop = isSet((isSet(val,[]).length>0)?isSet(isSet(val,[])[0].dependent_layout,{is_loop:false}).is_loop:false,false);
      let expression = [];
      let selectedValue = updateVal;
      if(isLoop===true){
          isSet(val,[]).map((expItm,expItmIndex)=>{
              if(expItmIndex===0 && expItm.dependent_layout.window_name){
                  expression.push(expItm.dependent_layout.window_name)
              }
              if(isSet(expItm.api_field_name,null)!==null){
                  expression.push(expItm.api_field_name);
              }
          })
          selectedValue=  '${'+expression.join('.')+'}';
      }
      const isVariableOrConstant = (isSet(val,[]).length>0)?
      isSet(isSet(val,[])[0].is_variable_or_constant,isSet(isSet(isSet(val,[])[0].dependent_layout,{is_variable_or_constant:false}).is_variable_or_constant,false))
          :false;
      if(isVariableOrConstant===true){
          selectedValue = selectedId;
      }   
      // console.log('selectedValue',selectedValue);
      
          const returnValue = [{
              name:dispName.join('.'),
              data_id:isSet((isSet(val,[]).length>0)?isSet(isSet(val,[])[0].dependent_layout,{data_id:null}).data_id:null,null),
              is_loop:isLoop,
              value:selectedValue,
              is_window_field:(isLoop===true && isVariableOrConstant===false)?true:false,
              is_variable_or_constant:isVariableOrConstant,
          }];
         value = returnValue;
    }

    this.updateReminderComponentObject({
      ...reminderJson,
      [obj]:value,
      ...stepsExtraObj
    });
    // console.log('reminderJson==',reminderJson);
  }

  actionChangeHandlerForFormula = (e,obj,value,isFromSteps=false,isTagType=false)=>{
    console.log('reminderJson== pre',obj,value);
    const {reminderJson} = this.state;

    let stepsExtraObj = {}
    if(isFromSteps === true){
      stepsExtraObj = {
        ['is_'+obj]:isTagType
      }
    }

    this.updateReminderComponentObject({
      ...reminderJson,
      [obj]:[value],
      ...stepsExtraObj
    });
    // console.log('reminderJson==',reminderJson);
  }


  // UPDATE REMINDER COMPONENET OBJECTS
  updateReminderComponentObject =(reminderObj)=>{
    const remind_period = reminderObj.remind_period;
    const remind_date = reminderObj.remind_date;
    const remind_time = reminderObj.remind_time;
    const repeat_type = reminderObj.repeat_type;
    const repeat_frequency = reminderObj.repeat_frequency;
    const repeat_weekday = reminderObj.repeat_weekday;
    const displayText = reminderObj.display_text;
    const remind_alert = reminderObj.remind_alert; 
    const email_template_id = reminderObj.email_template_id;
    const email_config_id = reminderObj.email_config_id;
    let validationCount = 0;
    // console.log(reminderObj);
    if(remind_time==='' || remind_time===null){
      validationCount++;
      // console.log(remind_time);
      // console.log('ss');
    }else if((remind_period!=='' && remind_period!==null && (remind_date==='' || remind_date===null)) && remind_time===''){
      validationCount++;
      // console.log(remind_period+'ss1'+remind_time);
    }
    if(displayText==='' || displayText===null || displayText.length===0){
      validationCount++;
      // console.log('ss11');
    }
    if(remind_alert===0||remind_alert===2){
      if(email_config_id===''|| email_config_id===null || email_config_id===undefined){
        validationCount++;
      }
      if(email_template_id===''|| email_template_id===null || email_template_id===undefined){
        validationCount++;
      }
   }
    //For Repeat;
    let repeatValidationCount = 0;
    if(repeat_type===4 && repeat_frequency===1 && repeat_weekday===0){
      repeatValidationCount++;
    }
    //console.log(validationCount);
    console.log('reminderObj==',reminderObj)
    this.setState({reminderJson:reminderObj,remindApplyButton:(validationCount===0)?false:true,
      repeatApplyButton:(repeatValidationCount===0)?false:true});
  } 
}

Reminder.defaultProps = {
  generator: false,
  className: "form-control"
}

const mapDispatchToProps = dispatch => {
  return {
  //   setVariablesPayloadAction:(obj)=>dispatch(setVariablesPayloadAction(obj)),
  };
}
const mapStateToProps = (state,props) => { 
  // console.log('props',props);
  return {
      // fieldGroups : state.formBuilder.fieldGroups[props.modType],
      nonFieldGroups : state.formBuilder.nonFieldGroups[props.modType],
  };
}
export default
  connect(
    mapStateToProps, 
    mapDispatchToProps
  )(withRouter(Reminder));
